





















import Vue from "vue";
import { aisleCategoryService } from "@/aisle-category/services/AisleCategoryService";
import { AisleCategory } from "@/aisle-category/models/AisleCategory";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";

export default Vue.extend({
  name: "AisleCategory",
  data() {
    return {
      breadcrumbs: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Aisle Category",
          disabled: true,
        },
      ],
      loading: false,
      search: "",
      headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Actions", value: "actions", align: "right", sortable: false },
      ],
      aisleCategories: [] as AisleCategory[],
    };
  },
  async mounted() {
    await this.updateList();
  },
  methods: {
    async goToEditItem(item: AisleCategory): Promise<void> {
      await this.$router.push({
        name: RouteInfoMap.get(Paths.AisleCategoryEdit)?.name,
        params: {
          aisleCategoryId: `${item.id}`,
        },
      });
    },
    async goToCreateItem(): Promise<void> {
      await this.$router.push({
        name: RouteInfoMap.get(Paths.AisleCategoryAdd)?.name,
      });
    },
    async deleteItem(aisleCategory: AisleCategory): Promise<void> {
      this.loading = true;
      const id = aisleCategory.id;
      if (!id) throw new Error("aisleCategory.id is required");
      try {
        await aisleCategoryService.deleteAisleCategory(id);
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
      await this.updateList();
    },
    async updateList(): Promise<void> {
      this.loading = true;
      try {
        this.aisleCategories = await aisleCategoryService.getAisleCategories();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
  },
});
